<template>
  <BaseModal
    name="AccrueCompanyPoints"
    width="420"
    height="auto"
    :clickToClose="false"
    :shiftY="0.5"
    :adaptive="true"
    classes="!tw-bg-transparent !tw-shadow-none"
  >
    <div
      class="tw-bg-white tw-rounded-[25px] tw-py-[38px] tw-px-[30px] tw-relative tw-text-forTitle"
    >
      <button
        type="button"
        class="btn-close tw-absolute tw-right-[30px] tw-top-[20px] !tw-shadow-none"
        @click="$modal.hide('AccrueCompanyPoints')"
      ></button>

      <div class="tw-text-center">
        <div class="tw-text-[23px] tw-mb-[15px]">Начислить баллы</div>

        <input
          class="tw-app-input-type-3 tw-mb-[15px]"
          v-model="modalData.score"
          @input="onInput"
          @change="onChange"
        />

        <div class="tw-text-left">
          <BaseTextarea
            :resize="false"
            @onInput="modalData.description = $event.value"
            :minHeight="'160'"
            inputClass="tw-app-input-type-3 tw-text-left"
            name-sign="Основание"
            :value="modalData.description"
          >
          </BaseTextarea>
        </div>

        <div
          v-if="errors && errors?.length != 0"
          class="tw-text-[12px] tw-text-danger tw-my-[30px]"
        >
          <div v-for="error in errors">
            <div v-for="message in error">
              {{ message }}
            </div>
          </div>
        </div>

        <div class="tw-flex tw-gap-[10px] tw-mt-[15px] tw-justify-center">
          <button
            @click="$modal.hide('AccrueCompanyPoints')"
            class="tw-app-btn-muted tw-app-btn-muted-lg"
          >
            Отменить
          </button>
          <button
            @click="submit()"
            class="tw-app-btn-primary tw-app-btn-primary-lg"
            :disabled="submitting"
          >
            Выполнить
          </button>
        </div>
      </div>
    </div>
  </BaseModal>
</template>

<script>
import GeneralService from "@/api/GeneralService";
import EventBus from "@/event-bus.js";

export default {
  components: {},
  props: ["modalInfo"],
  data() {
    return {
      modalData: {
        score: null,
        description: null,
      },
      submitting: false,
      errors: null,
    };
  },
  methods: {
    submit() {
      this.submitting = true;
      GeneralService.editOrCreate(
        `/super/companies/tab/score/table/up/${this.modalInfo.id}`,
        this.modalData
      )
        .then((data) => {
          this.$toast.success(data.data.message);
          this.$modal.hide("AccrueCompanyPoints");
          this.$emit("update");
          this.modalData = {
            score: null,
            description: null,
          };
          this.errors = null;
          EventBus.$emit("headerUserInfoEventBus");
        })
        .catch((e) => {
          this.$toast.error(e.response.data.message, { duration: 5000 });
          this.errors = e.response.data.errors;
        })
        .finally(() => {
          this.submitting = false;
        });
    },
    onChange() {
      let num = parseFloat(this.modalData.score);

      // Если поле пустое или меньше 0.01, приводим к минимальному порогу
      if (isNaN(num) || num < 0.01) {
        this.modalData.score = "0.01";
      }
    },
    onInput(event) {
      // 1. Получаем текущее значение
      let value = event.target.value;

      // 2. Заменяем запятую на точку
      value = value.replace(",", ".");

      // 3. Удаляем все символы, кроме цифр и точки
      value = value.replace(/[^0-9.]/g, "");

      // 4. Оставляем только первую точку
      const parts = value.split(".");
      if (parts.length > 2) {
        value = parts[0] + "." + parts.slice(1).join("");
      }

      // 5. Ограничиваем дробную часть до 2 знаков после точки
      if (parts && parts.length > 1) {
        value = parts[0] + "." + parts[1].slice(0, 2);
      }

      // 6. Проверяем максимальный предел (1000)
      let num = parseFloat(value);
      if (!isNaN(num) && num > 999) {
        value = "999";
      }

      // 7. Обновляем v-model и DOM
      this.modalData.score = value;
      event.target.value = value;
    },
  },
};
</script>
